import { PlaceReport } from "../../../models";
import { DataProviderArgs } from "../../DataStore/DataProvider";
import { Kernel } from "../../Kernel";
import { getModuleLog } from "../../Logger";
import { IPlaceReport, awsToSimpleObject } from "../../models/Models";
import { IPlaceReportTable } from "../IPlaceReportTable";
import { awsPlaceReportToSimplePlaceReport } from "../IPlaceTable";
import { DataStoreTable } from "./DataStoreTable";

export class PlaceReportTable extends DataStoreTable<IPlaceReport> implements IPlaceReportTable {
    constructor(args: DataProviderArgs) {
        super(
            args,
            "place-report",
            PlaceReport,
            (obj: any) => awsPlaceReportToSimplePlaceReport(obj),
            (obj: any) => new PlaceReport(obj)
        );
    }

    public async allByPlaceId(id: string, ..._args: any[]): Promise<IPlaceReport[] | undefined> {
        const all = await this.all();
        return Array.from(all.filter((x: IPlaceReport) => x.placeReportsId === id));
    }

    public async fixItemsWithNoOwner() {
        const log = getModuleLog("place-report");
        const owner = Kernel.instance().user?.id;
        if (owner) {
            const items = await this.all();
            items.forEach((item) => {
                if (!item.owner || item.owner === "") {
                    log.info(`Item ${item.id} has no owner - fixing`);
                    const copy = awsToSimpleObject(item);
                    copy.owner = owner;
                    delete (copy as any).id;
                    this.create(new PlaceReport(copy));
                    this.delete(item.id);
                }
            });
        }
    }
}
